import Tr from 'translations/Translations';

export const AuctionStatus = {
    INCOMPLETE: "INCOMPLETE",
    PENDING: "PENDING",
    OPEN: "OPEN",
    PAUSED: "PAUSED",
    FINISHED: "FINISHED",
    ACCEPTED: "ACCEPTED",
    CANCELLED: "CANCELLED"
}
const _TR_PREFIX = 'auction_status_';

export const AuctionStatusLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
